import { List, Record } from 'immutable';
const ArticleVersionsRecord = Record({
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  objects: new List(),
  total: 0,
  offset: 0,
  limit: 0,
  error: null,
  isRequesting: false,
  lastLoaded: null
});
export default ArticleVersionsRecord;